export const iaResponseAdapter = (data, tiposComprobante = [], opcionesTipoCaeCai = [], conceptoDelGastoSelected = null) => {
    if (!data) return null;
    let adapted = {};

    adapted.idConceptoDelGasto = conceptoDelGastoSelected ? conceptoDelGastoSelected.id : null;
    adapted.concepto = conceptoDelGastoSelected ? conceptoDelGastoSelected.descripcion : "";

    const tipoComp = tiposComprobante.find(tc => tc.id === data.codigo_tipo_comprobante);
    adapted.idTipoComprobante = tipoComp ? tipoComp.id : 71;
    adapted.comprobante = tipoComp ? tipoComp.descripcion : "Otros comprobantes";
    adapted.sinCaeCai = tipoComp ? tipoComp.sinCae : false;

    const tipoAuth = opcionesTipoCaeCai.find(ta => ta.id === data.codigo_tipo_auth);

    adapted.tipoCaeCai = tipoAuth ? tipoAuth.id : null;
    adapted.tipoCaeCaiDesc = tipoAuth ? tipoAuth.nombre : "";

    adapted.caeCai = data.numero_auth || "";
    adapted.puntoVenta = data.punto_venta;
    adapted.numero = data.numero_factura;

    adapted.razonSocial = data.nombre_emisor || "";
    adapted.cuit = data.cuit_emisor || "";

    adapted.fecha = data.fecha || "";

    adapted.importe = data.importe_total ? data.importe_total.toString().replace(".", ",") : "";
    adapted.motivoGasto = data.motivo_gasto || "";

    return adapted;
};